/* eslint-disable no-unused-vars */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { prefersReducedMotion } from '../../utils';
import { App } from './App';
import { resetState } from './XRScene/state';

export default function (el) {
  if (prefersReducedMotion) {
    // activate fallback
    el.classList.add('fallback');
    return;
  }

  const root = createRoot(el);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // Detect if DOM node that holds React app is removed
  // const unmountObserver = new MutationObserver(function (mutations_list) {
  //   if (!el.isConnected) {
  //     unmountObserver.disconnect();
  //     // Reset XR App state
  //     resetState();
  //     // Unmount React App to prevent memory leak
  //     root.unmount();
  //   }
  // });
  // unmountObserver.observe(document.body, { childList: true, subtree: true });
}
